export enum Lang {
    En = 1,
    Ru = 2,
}
